export const ACTION_NAME_DOC_ID = "action_name_doc_id";
export const ANNOTATIONS = "annotations";
export const ARRAY = "array";
export const ATTORNEY_NAME = "attorney_name";
export const ATTORNEY_NAME_ARRAY = "attorney_name_array";
export const ATTORNEY_NAME_ID = "attorney_name_id";
export const ATTORNEY_NAME_ID_ARRAY = "attorney_name_id_array";
export const CASE_CITE = "case_cite";
export const CASE_LINK = "case_link";
export const CASE_NAME_ID = "case_name_id";
export const CASE_NUMBER_ID = "case_number_id";
export const COLORED_TEXT = "colored_text";
export const COURT_ABBREV_ID = "court_abbreviation_id";
export const DATE = "date";
export const DOCUMENT_LINK = "document_link";
export const DOCUMENT_ID = "document_id";
export const EXPERT_NAME_ID = "expert_name_id";
export const FIRM_NAME_ID = "firm_name_id";
export const FLOAT = "float";
export const INLINE_TABLE = "inline_table";
export const INT = "int";
export const JUDGE_NAME_ID = "judge_name_id";
export const MONEY = "money";
export const PARAGRAPH = "paragraph";
export const PARTY_NAME_ID = "party_name_id";
export const PATENT_NAME_ID = "patent_name_id";
export const PATENT_NUMBER_ID = "patent_number_id";
export const PDF_URL = "pdf_url";
export const REPS = "reps";
export const RESULT_NAME_COLOR = "result_name_color";
export const SNIPPET = "snippet";
export const TABLE = "table";
export const TEXT = "text";
export const TITLE_COLOR = "title_color";
export const TITLE_URL = "title_url";
export const TITLED_TABLE = "titled_table";
